import { destroy, get, post, put, patch } from './helpers/fetch';
import join from 'url-join';
import { SLOW_REQUEST_THRESHOLD } from '../constants/urls';

export default class MediaDAO {

  accessToken: string;
  apiUrl: string;
  logging: Object;

  constructor(accessToken: string, mediaUrl: string, logger: Object) {
    this.accessToken = accessToken;
    this.apiUrl = mediaUrl;
    this.logging = { logger, loggingThreshold: SLOW_REQUEST_THRESHOLD };
  }

  uploadImage(asset: FormData) {
    return post({
      accessToken: this.accessToken,
      url: join(this.apiUrl, 'upload'),
      formData: asset,
      ...this.logging,
    });
  }

  getUrl() {
    return join(this.apiUrl);
  }
}